import React, { FunctionComponent, PropsWithChildren } from "react";
import NextImage, { StaticImageData } from "next/image";
import getBootstrapSizes from "@adjust/website/libs/helper/getBoostrapSizes";
import { css } from "@adjust/libs/emotion";

//========================================================
//  Emotion Constants
//========================================================

const contentCss = css({
  position: "relative",
  overflow: "hidden", // keeps background contained
});

const wrapperCss = css({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: -1, // behind children
});

const imageCss = css({
  objectFit: "cover",
  width: "100%",
  height: "100%",
});

//========================================================
//  Static Background Component
//========================================================

type StaticBackgroundProps = {
  bgImage: StaticImageData;
  bgImageAlt: string;
  quality?: number;
  priority?: boolean;
  fetchPriority: "auto" | "high" | "low";
};

const sizes = getBootstrapSizes({ xs: 640, md: 1200, xl: 1920 });

const StaticBackgroundComponent: FunctionComponent<PropsWithChildren<StaticBackgroundProps>> = ({ bgImage, bgImageAlt, children, priority, fetchPriority, quality }) => {
  return (
    <div className={contentCss}>
      <div className={wrapperCss}>
        <NextImage
          className={imageCss}
          src={bgImage}
          alt={bgImageAlt}
          style={{ objectFit: "cover" }}
          fill={true}
          objectFit="cover"
          quality={quality || 80}
          sizes={sizes}
          placeholder={priority ? "empty" : "blur"}
          blurDataURL={bgImage.blurDataURL}
          priority={priority}
          fetchPriority={fetchPriority}
        />
      </div>
      <div>{children}</div>
    </div>
  );
};

export default StaticBackgroundComponent;
